import TagComponent from './TagComponent'
import DeviceId from './DeviceId'
import NotificationMenu from './NotificationMenu'
import CopyLink from './CopyLink'
import NotificationSearch from './NotificationSearch'
import CopyNotification from './CopyNotification'
import AttachmentsMenu from './AttachmentsMenu'
import AttachmentsViewer from './AttachmentsViewer'
import PolicyCard from './PolicyCard'
import VuexRule from './VuexRule'
import ArrayEditor from './ArrayEditor'
import { component as VueCodeHighlight } from 'vue-code-highlight'
import TitledWarning from './TitledWarning'
import AttributeTable from './AttributeTable'
import NotificationAttributes from './NotificationAttributes'
import ConversationSnapshot from './ConversationSnapshot'
import DeviceTypes from './DeviceTypes'
import SubjectCard from './SubjectCard'
import ExclusionCard from './ExclusionCard'

const register = {
  TagComponent,
  DeviceId,
  NotificationMenu,
  CopyLink,
  NotificationSearch,
  CopyNotification,
  AttachmentsMenu,
  AttachmentsViewer,
  PolicyCard,
  VuexRule,
  ArrayEditor,
  VueCodeHighlight,
  TitledWarning,
  AttributeTable,
  NotificationAttributes,
  ConversationSnapshot,
  DeviceTypes,
  SubjectCard,
  ExclusionCard,
}

// all global registration
export default (Vue) => {
  Object.keys(register)
    .forEach(key => Vue.component(key, register[key]))
}